<template>
    <div class="bid-review-container">
        <div class="contract-top" v-has="'02010021'">
            <el-button class="bigData-btn-organization-mip" type="primary" :disabled="auditDisabled" @click="examine">标书MIP审核</el-button>
        </div>
        <div>
            <el-form :model="form" label-width="150px" class="wrapper-form contractInfo-form" ref="form">
                <el-form-item class="item" :md="8" :lg="6" label="组织者" prop="organizerName">
                    <el-input placeholder="请输入内容" v-model="form.organizerName" :disabled="true">
                        <el-button slot="append" icon="el-icon-search" :disabled="true"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="分公司" prop="companyName">
                    <mInput :params="companyNameData" :mValue="form.companyName" :disabled="true"></mInput>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="经营中心" prop="centerName">
                    <el-input v-model="form.centerName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="服务平台" prop="siteName">
                    <mInput
                        :params="siteNameData"
                        :formData="siteFormData"
                        :mValue="form.siteName"
                        :disabled="true"></mInput>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="业务类型" prop="businessType">
                    <MSelect
                        :optionNum="'BID_BUSINESS_TYPE'"
                        :value="form.businessType"
                        :filterable="true"
                        :disabled="true"></MSelect>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="客户类型" prop="customerType">
                    <MSelect
                        :optionNum="'SRM_CONTRACT_IS_GROUP_CUSTOMER'"
                        :value="form.customerType"
                        :filterable="true"
                        :disabled="true"></MSelect>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="客户" prop="customerName">
                    <el-tooltip class="item" effect="dark" :content="form.customerName" placement="top">
                        <div slot="content">
                            <div
                                v-for="item in form.customers"
                                :key="item.customerName"
                                class="td-customerName-tooltip-item">
                                {{ item.customerName }}
                            </div>
                        </div>
                        <mInput
                            :params="customerParams"
                            :formData="{}"
                            :mValue="form.customerName"
                            :cacheData="customersCache"
                            :disabled="true"
                            :maxSelect="customerParams.max"></mInput>
                    </el-tooltip>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="专业公司" prop="professionalCompany">
                    <MSelect
                        :optionNum="'SYS_PROFESSIONAL_COMPANY'"
                        :value="form.professionalCompany"
                        :disabled="true"
                        :filterable="true"></MSelect>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="业务规模(元)" prop="businessScale">
                    <div class="business-scale-content">
                        <el-input-number
                            v-model="form.businessScale"
                            controls-position="right"
                            :precision="2"
                            :step="1"
                            :disabled="true"
                            :min="0"
                            :max="9999999999.99"></el-input-number>
                        <span class="business-scale-myriad" :style="businessScaleDiasbled ? 'color:#c3c7c7;' : ''">
                            {{ businessScaleMyriad }} 万元
                        </span>
                    </div>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="报名截止时间" prop="signUpEndTime">
                    <el-date-picker
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptionsOhterStart"
                        v-model="form.signUpEndTime"
                        :disabled="true"
                        type="datetime"
                        placeholder="0000-00-00 00:00"></el-date-picker>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="报价开始时间" prop="quoteStartTime">
                    <el-date-picker
                        v-model="form.quoteStartTime"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm:ss"
                        :disabled="true"
                        :picker-options="pickerOptionsQuoteStart"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="0000-00-00 00:00"></el-date-picker>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="标书定价(元)" prop="bidPrice">
                    <el-input-number
                        v-model="form.bidPrice"
                        controls-position="right"
                        :precision="2"
                        :step="1"
                        :disabled="true"
                        :min="0"
                        :max="9999999999"></el-input-number>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="投标保证金金额(元)" prop="deposit">
                    <el-input-number
                        v-model="form.deposit"
                        controls-position="right"
                        :precision="2"
                        :disabled="true"
                        :step="1"
                        :min="0"
                        :max="9999999999"></el-input-number>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="是否维护拦标价" prop="blockPriceControl">
                    <MSelect
                        :optionNum="'BID_YES_NO'"
                        :value="form.blockPriceControl"
                        :disabled="true"
                        :filterable="true"></MSelect>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="联合招标分公司" prop="unionBidCompanyName">
                    <el-tooltip class="item" effect="dark" :content="form.unionBidCompanyName" placement="top">
                        <div slot="content">
                            <div
                                v-for="item in form.unionBidCompanyList"
                                :key="item.customerCode"
                                class="td-customerName-tooltip-item">
                                {{ item.customerName }}
                            </div>
                        </div>
                        <mInput
                            :disabled="true"
                            :params="jointBiddingCompany"
                            :formData="{}"
                            :mValue="form.unionBidCompanyName"
                            :cacheData="unionBidCompanyNameCache"
                            :maxSelect="jointBiddingCompany.max"></mInput>
                    </el-tooltip>
                </el-form-item>
                <el-form-item class="item" :md="8" :lg="6" label="是否防倒挂" prop="priceBarb">
                    <MSelect
                        :optionNum="'SRM_YES_NO'"
                        :value="form.priceBarb"
                        :filterable="true"
                        :disabled="true"></MSelect>
                </el-form-item>
                <div class="url-wd">
                    <el-form-item class="item" :md="8" :lg="6" label="审批流链接" prop="priceBarb">
                        <span class="mip-url" @click="onMip(form.bidHeadFdUrl)">{{ form.bidHeadFdUrl }}</span>
                    </el-form-item>
                </div>
            </el-form>
        </div>

        <!-- <contractInfo ref="contractInfo" :form="form" :siteFormData="siteFormData" :isPrivilege="isPrivilege" :openPerDialog="openPerDialog"></contractInfo> -->
    </div>
</template>
<script>
import MSelect from '@/components/lots/otpSelect2'
import mInput from '@/components/lots/otpAdvance'
import { mipSpecial, isFlower, seachMaintain } from '../../../../api/bidScheme.js'
import { SRM_YES } from '../../../../constant/constant.js'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'

//联合招标分公司
const jointBiddingCompany = {
    name: '联合招标分公司',
    value: 'unionBidCompanyName',
    advanceLabel: '分公司弹出框',
    advanceConfig: [
        { prop: 'companyNameCn', value: '分公司名称' },
        { prop: 'companyCode', value: '分公司编码' },
    ],
    tableConfig: [
        { prop: 'companyNameCn', value: '分公司名称' },
        { prop: 'companyCode', value: '分公司编码' },
    ],
    advanceUrl: '/esCompany/popCompany',
    cbParams: ['companyCode#unionBidCompanyCode', 'companyNameCn#unionBidCompanyName'],
    multiple: true,
    multipleTableConfig: [
        { prop: 'companyCode', value: '分公司编码' },
        { prop: 'companyNameCn', value: '分公司名称' },
    ],
    max: 20,
}
const customerParams = {
    name: '客户',
    value: 'customerName',
    advanceLabel: '客户弹出框',
    advanceConfig: [
        { prop: 'ebcuNameCn', value: '客户名称' },
        { prop: 'pmCode', value: '客户编码' },
    ],
    tableConfig: [
        { prop: 'ebcuNameCn', value: '客户名称' },
        { prop: 'pmCode', value: '客户编码' },
    ],
    advanceUrl: '/ebCustomer/searchByEbCustomer',
    cbParams: ['pmCode#customerCode', 'ebcuNameCn#customerName'],
    multiple: true,
    multipleTableConfig: [
        { prop: 'pmCode', value: '客户编码' },
        { prop: 'ebcuNameCn', value: '客户名称' },
    ],
    max: 20,
}

export default {
    components: { MSelect, mInput },
    data() {
        return {
            form: {
                bidNo: '',
                bidName: '',
                organizerCode: '',
                companyCode: '',
                siteCode: '',
                bidStatus: '',
                organizerName: '',
                companyName: '',
                siteName: '',
                centerCode: '',
                centerName: '',
                signUpEndTime: '',
                purchaseStartTime: '',
                depositEndTime: '',
                quoteStartTime: '',
                currency: '',
                bidPrice: '',
                deposit: '',
                businessScale: '',
                lowerLastRound: '',
                quotePrecision: 0,
                round: '',
                rankedVisible: '',
                ralationQuote: '',
                lowestQuoteVisible: '',
                blockPriceMaintain: '',
                syntheticalScore: '',
                skillProportion: '',
                businessProportion: '',
                extraProportion: '', // 附加分权重(%)
                priceProportion: '',
                blockPriceControl: '',
                changeBidMin: '',
                priceMax: '',
                specialPermitFlag: '',
                remarks: '',
                professionalCompany: '',
                accountEntity: '',
                accountEntityName: '',
                accountCompanyName: '',
                businessType: '',
                servicesType: '',
                contractEffectiveTime: '',
                contractSuspendTime: '',
                taxRate: '',
                cashRation: '',
                oilCardRation: '',
                acceptanceRation: '',
                contractDepositRation: '',
                invoiceType: '',
                paymentTerms: '',
                customerType: '',
                transType: '',
                liquidatedDamagesRation: '',
                needCollect: '',
                collectTypeCode: [],
                customerCode: '',
                customerName: '',
                customers: [],
                unionBidCompanyList: [],
            },
            siteFormData: { companyCode: '' },
            isPrivilege: false, // 是否点击了特权修改按钮
            dictData: {},
            businessScaleDiasbled: false,
            jointBiddingCompany,
            customerParams,
            unionBidCompanyNameCache: [], // 联合招标分公司弹窗缓存
            // 分公司
            companyNameData: {
                value: 'companyName',
                advanceConfig: [
                    { prop: 'companyNameCn', value: '分公司名称' },
                    { prop: 'companyCode', value: '分公司编码' },
                ],
                advanceUrl: '/esCompany/popCompany',
                cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
                name: '分公司',
                tableConfig: [
                    { prop: 'companyCode', value: '分公司编码' },
                    { prop: 'companyNameCn', value: '分公司名称' },
                ],
            },
            // 服务平台
            siteNameData: {
                value: 'siteName',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                ],
                advanceUrl: '/searchPlatform?escoStatus=ENABLE',
                advancePrefix: 'web-bms',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                name: '服务平台',
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '服务平台编码' },
                    { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                ],
                advanceCascade: `companyCode#companyCode`,
            },
            siteFormData: {},
            customersCache: [], // 合同客户弹窗缓存
        }
    },

    mounted() {
        // // 数字字典
        // this.APPENDIX_TYPE()
        // dictWithUrl('SYS_COLLECT_TYPE').then(item => {
        //     this.dictData = item.data
        // })
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'tenantCode']),
        loginState() {
            return this.$store.state.bidData
        },
        businessScaleMyriad() {
            const businessScale = this.form.businessScale
            const num = businessScale / 10000 || 0
            const parts = num.toString().split('.')
            if (parts.length === 1) return num // 没有小数部分
            const decimalPart = parts[1].slice(0, 2)
            return `${parts[0]}.${decimalPart}`
        },
        pickerOptionsOhterStart() {
            return {
                disabledDate: time => {
                    //报价开始时间的日历只能选择比截止时间、标书购买开始时间、保证金提交截止时间大的日期
                    const quoteStartTimeCheck = this.form.quoteStartTime
                        ? time.getTime() > dayjs(this.form.quoteStartTime).valueOf()
                        : false
                    return time.getTime() < new Date(new Date().toLocaleDateString()).getTime() || quoteStartTimeCheck
                },
            }
        },
        pickerOptionsQuoteStart() {
            return {
                disabledDate: time => {
                    //截止时间、标书购买开始时间、保证金提交截止时间的日历只能选择比报价开始时间小的日期
                    const signUpEndTimeCheck = this.form.signUpEndTime
                        ? time.getTime() < dayjs(this.form.signUpEndTime).startOf('day').valueOf()
                        : false
                    const purchaseStartTimeCheck = this.form.purchaseStartTime
                        ? time.getTime() < dayjs(this.form.purchaseStartTime).startOf('day').valueOf()
                        : false
                    const depositEndTimeCheck = this.form.depositEndTime
                        ? time.getTime() < dayjs(this.form.depositEndTime).startOf('day').valueOf()
                        : false
                    return (
                        time.getTime() < new Date(new Date().toLocaleDateString()).getTime() ||
                        purchaseStartTimeCheck ||
                        depositEndTimeCheck ||
                        signUpEndTimeCheck
                    )
                },
            }
        },
        auditDisabled() {
            // 是否召回招标为是，则禁用审核按钮
            return this.loginState.isRecall === SRM_YES
        },
    },
    methods: {
        // 标书MIP审核 iframe链接接口
        async examine() {
            // 查询是否有维护技术和商务
            const isMaintain = await seachMaintain(this.$route.query.bidNo) // 判断是否符合MIP审核
            if (isMaintain && isMaintain.code === '0') {
                const flowerRes = await isFlower({ bussinessCode: this.$route.query.bidNo, auditType: '2' }) // 判断是否有流程
                if (flowerRes.data.list.length !== 0) {
                    // 有流程
                    this.haveMipFn(flowerRes.data.list[0])
                } else {
                    // 没有流程发起流程
                    const strUrl = `${location.origin}${location.pathname}#${this.$route.path}?bidNo=${this.$route.query.bidNo}&defaultComponent=BidReview`
                    if (this.loginState.specialPermitFlag === 'Y') {
                        // 特批
                        const res = await mipSpecial(
                            {
                                tenantCode: this.currentTenant.tenantCode,
                                appCode: this.applicationCode,
                                fdTemplateCode: 'srm_bid_team',
                                loginName: this.$store.getters.user.userCode,
                                bidNo: this.$route.query.bidNo,
                                formParam: {
                                    subject:
                                        this.$route.query.bidNo +
                                        '_' +
                                        this.loginState.bidName +
                                        '_标书审批_' +
                                        this.$store.getters.user.userName,
                                    formInstanceId: this.$route.query.bidNo,
                                    fdUrl: strUrl,
                                },
                            },
                            'N',
                        )
                        this.haveMipFn(res.data)
                    } else {
                        // 不特批
                        const res = await mipSpecial(
                            {
                                tenantCode: this.currentTenant.tenantCode,
                                appCode: this.applicationCode,
                                fdTemplateCode: 'srm_bid_team',
                                loginName: this.$store.getters.user.userCode,
                                bidNo: this.$route.query.bidNo,
                                formParam: {
                                    subject:
                                        this.$route.query.bidNo +
                                        '_' +
                                        this.loginState.bidName +
                                        '_标书审批_' +
                                        this.$store.getters.user.userName,
                                    formInstanceId: this.$route.query.bidNo,
                                    fdUrl: strUrl,
                                },
                            },
                            'N',
                        )
                        this.haveMipFn(res.data)
                    }
                }
            }
        },
        haveMipFn(flowerRes) {
            this.$router.push({
                name: 'mipIframe',
                query: {
                    processId: flowerRes.fdId,
                    path: 'bidScheme',
                    formInstanceId: this.$route.query.bidNo,
                    noticeCode: this.$route.query.bidNo,
                    isBack: true,
                },
            })
        },
        onMip(url) {
            let urlData = this.parseURL(url)
            // let fdid = ''
            // if (this.form.fdIds.includes(',')) {
            //     fdid = this.form.fdIds.split(',')[0]
            // } else {
            //     fdid = this.form.fdIds
            // }
            this.$router.push({
                name: 'mipIframe',
                query: {
                    processId: urlData.fdId,
                    path: 'tendermanagement',
                    formInstanceId: urlData.fdTemplateKey,
                },
            })
        },
        parseURL(url) {
            const regex = /^(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?$/
            const result = regex.exec(url)
            const query = {}
            const queryString = result[4]
            if (queryString) {
                let pairs = queryString.substring(0).split('&')
                for (let i = 0; i < pairs.length; i++) {
                    let pair = pairs[i].split('=')
                    let key = decodeURIComponent(pair[0])
                    let value = decodeURIComponent(pair[1] || '')
                    query[key] = value
                }
            }
            return query
        },
        setJointBiddingCompanyCache() {
            if (this.form.unionBidCompanyList && this.form.unionBidCompanyList.length) {
                this.unionBidCompanyNameCache = this.form.unionBidCompanyList.map(item => {
                    return {
                        companyCode: item.customerCode,
                        companyNameCn: item.customerName,
                    }
                })
            } else {
                this.unionBidCompanyNameCache = []
                // this.formObj.unionBidCompanyCode = "";
                // this.formObj.unionBidCompanyName = "";
            }
        },

        setCustomersCache() {
            if (this.form.customers && this.form.customers.length) {
                this.customersCache = this.form.customers.map(item => {
                    return {
                        pmCode: item.customerCode,
                        ebcuNameCn: item.customerName,
                    }
                })
            } else {
                this.customersCache = []
            }
        },
    },
    watch: {
        loginState: {
            handler(val) {
                this.form = val
                if (val.businessScale && (val.bidStatus === '00' || val.bidStatus === '20')) {
                    this.businessScaleDiasbled = true
                } else {
                    this.businessScaleDiasbled = false
                }
                this.form.extraProportion = 100 // 附加分权重写死100%
                if (
                    this.form.collectTypeCode &&
                    Object.prototype.toString.call(this.form.collectTypeCode).slice(8, -1) === 'String'
                ) {
                    this.form.collectTypeCode = this.form.collectTypeCode.split(',')
                }
                this.siteFormData.companyCode = val.companyCode
                if (this.form.currency === null) {
                    this.form.currency = 'CNY'
                }
                if (this.form.rankedVisible === null || this.form.rankedVisible === '') {
                    this.form.rankedVisible = '2'
                }
                if (this.form.priceMax === null) {
                    this.form.priceMax = undefined
                }
                if (this.form.customers) {
                    this.form.customerCode = this.form.customers.map(item => item.customerCode).join(',')
                    this.form.customerName = this.form.customers.map(item => item.customerName).join(',')
                }
                this.setJointBiddingCompanyCache()
                this.setCustomersCache()
                // this.init()
            },
            immediate: true,
            deep: true,
        },
    },
}
</script>
<style lang="less">
.bid-review-container {
    display: flex;
    overflow: auto;
    padding: 16px;
    background-color: #fff;
    flex-direction: column;
    flex: 1 auto;

    .el-input--prefix .el-input__inner {
        padding-left: 22px;
    }

    .el-form-item__content .el-input-group {
        margin-top: 5px;
    }

    .el-form-item__content {
        height: 33px;
    }

    .wrapper-form {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 10px;

        .el-form-item {
            margin-bottom: 5px;
            // width: 23%;
            height: 35px;
        }
    }

    .item div:first-child {
        width: 180px !important;
    }

    .contractInfo-form {
        .url-wd {
            min-width: 660px;
        }

        .item {
            .business-scale-content {
                .el-input-number {
                    width: 100px !important;
                }

                .el-input-number__increase {
                    display: none;
                }

                .el-input-number__decrease {
                    display: none;
                }

                .el-input-number.is-controls-right .el-input__inner {
                    padding-right: 0;
                    padding-left: 0;
                }
            }
        }

        .business-scale-myriad {
            position: absolute;
            top: 0;
            left: 102px;
            font-size: 12px;
            white-space: nowrap;
            color: #555757;
        }
    }

    .mip-url {
        color: #00bcbf;
        cursor: pointer;
    }

    .el-input.is-disabled .el-input__inner {
        color: #666;
    }
}
</style>
